import React, { useEffect, useRef } from "react";
import { useServiceHealthStatus } from "../../hooks/useServiceHealthStatus";
import { renderAlert } from "../Alert/Alert";
import { useDispatch } from "react-redux";
import { setIsOneDriveServiceWorking, setTriggerSave } from "../../redux/action/userActivityAction";
import { useOnlineStatus } from "../../hooks/useOnlineStatus";
import ServiceHealthOverlay from "../../containers/Overlays/ServiceHealthOverlay/ServiceHealthOverlay";


const ServiceHealthWatcher: React.FC = () => {

  const isOnline = useOnlineStatus();
  const dispatch = useDispatch<any>();
  const { hasIssue, gatewayStatus, downServices, error } =
    useServiceHealthStatus(isOnline);

  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);


  const onlyOneDriveDown =
    downServices.length === 1 && downServices[0] === "onedrive-service";

  const isOneDriveDown = downServices.includes("onedrive-service");

  const nonOneDriveDown = downServices.filter(
    (name) => name !== "onedrive-service"
  );

  const prevDisableConnectRef = useRef<boolean | null>(null);

  useEffect(() => {
    if (onlyOneDriveDown && gatewayStatus === "UP") {
      renderAlert(
        "The OneDrive service is currently unavailable. Some features may not function as expected.",
        "warning"
      );

      if (!intervalRef.current) {
        intervalRef.current = setInterval(() => {
          renderAlert(
            "The OneDrive service is still unavailable. Some features may continue to be affected.",
            "warning"
          );
        }, 30000);
      }
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [onlyOneDriveDown, gatewayStatus]);

  useEffect(() => {
    const disableConnect =
      gatewayStatus === "DOWN" || isOneDriveDown || !!error;

    const prevDisableConnect = prevDisableConnectRef.current;

    if (prevDisableConnect === true && disableConnect === false) {
      renderAlert(
        "The OneDrive service has been restored. Please retry the connection.",
        "success"
      );
    }

    prevDisableConnectRef.current = disableConnect;

    dispatch(setIsOneDriveServiceWorking(!disableConnect));
  }, [gatewayStatus, isOneDriveDown, error, dispatch]);

  const openOverlay =
    gatewayStatus === "DOWN" ||
    nonOneDriveDown.length > 0 ||
    (!!error && !onlyOneDriveDown);

    const prevOpenRef = useRef<boolean>(openOverlay);

    useEffect(() => {
      if (prevOpenRef.current === true && openOverlay === false) {
        dispatch(setTriggerSave(true));
      }
      prevOpenRef.current = openOverlay;
    }, [openOverlay]);

  return (
    <ServiceHealthOverlay
      open={openOverlay}
      gatewayStatus={gatewayStatus}
      downServices={nonOneDriveDown} 
      error={error}
    />
  );
};

export default ServiceHealthWatcher;
